import { get, put, post } from "@/shared/utils/fetchApi";
import type { EmailServiceConfig } from "../types/EmailServiceConfigInterface";
import type { UpdateEmailServicePayload } from "../types/UpdateEmailServicePayload";
import type { TestEmailServicePayload } from "../types/TestEmailServicePayload";

/**
 * Service para gerenciar configurações de email service
 * Apenas usuários com role='superadmin' podem acessar
 */
export class EmailServiceService {
  /**
   * Busca a configuração atual de email service
   * Retorna com senhas/API keys mascaradas
   */
  static async getConfig(): Promise<EmailServiceConfig> {
    // v2: `GET /email-service` (superadmin) config flat, secrets mascarados. Paridade legacy (flat).

    return get<EmailServiceConfig>("/email-service");
  }

  /**
   * Atualiza a configuração de email service
   * Criptografa senhas/API keys na secrets_base automaticamente
   *
   * @param config Configuração atualizada
   */
  static async updateConfig(
    config: UpdateEmailServicePayload,
  ): Promise<{ success: boolean; message: string }> {
    // PUT `/email-service` → {success,message}. Mensagem em EN (divergência menor).

    return put<{ success: boolean; message: string }>(
      "/email-service",
      config,
    );
  }

  /**
   * Testa a configuração de email antes de salvar
   *
   * @param config Configuração a ser testada
   * @param testEmail Email para enviar o teste
   */
  static async testConfig(
    payload: TestEmailServicePayload,
  ): Promise<{ success: boolean; message: string }> {
    // POST `/email-service/test` → {success,message}. Só microsoft365 testável (501 nos demais).

    return post<{ success: boolean; message: string }>(
      "/email-service/test",
      payload,
    );
  }
}
